import { api } from '@/lib/api';
import type { IApiResponse, IIncident, IIncidentListFilters, IIncidentSummary } from '@skystone/shared';

export const incidentApi = {
  getAll: async (filters?: IIncidentListFilters): Promise<IIncident[]> => {
    const params = new URLSearchParams();
    if (filters?.productId) params.set('productId', filters.productId);
    if (filters?.from) params.set('from', filters.from);
    if (filters?.to) params.set('to', filters.to);
    if (filters?.includeUnassigned !== undefined) params.set('includeUnassigned', String(filters.includeUnassigned));
    if (filters?.includeArchived !== undefined) params.set('includeArchived', String(filters.includeArchived));
    const query = params.toString();
    const url = query ? `/incidents?${query}` : '/incidents';
    const result = await api.get<IApiResponse<IIncident[]>>(url);
    return result.data;
  },

  getSummary: async (filters?: IIncidentListFilters): Promise<IIncidentSummary> => {
    const params = new URLSearchParams();
    if (filters?.productId) params.set('productId', filters.productId);
    if (filters?.from) params.set('from', filters.from);
    if (filters?.to) params.set('to', filters.to);
    if (filters?.includeUnassigned !== undefined) params.set('includeUnassigned', String(filters.includeUnassigned));
    if (filters?.includeArchived !== undefined) params.set('includeArchived', String(filters.includeArchived));
    const query = params.toString();
    const url = query ? `/incidents/summary?${query}` : '/incidents/summary';
    const result = await api.get<IApiResponse<IIncidentSummary>>(url);
    return result.data;
  },
};
